try {
  (function () {
    var flexSpots = Array.prototype.slice.call(document.querySelectorAll('.flex-spot'));
    flexSpots.forEach(function (flexSpot) {
      var allElements = Array.prototype.slice.call(flexSpot.querySelectorAll('.element'));

      // for each element
      // check if there is a link
      // if there is one link and one image - give the image that link
      // if there are several images and several links - give the image the link that follows directly after that image

      allElements.forEach(function (element) {
        var allLinks = Array.prototype.slice.call(element.querySelectorAll('.element__item__link'));
        var allImages = Array.prototype.slice.call(element.querySelectorAll('.element__item__image'));
        if (allLinks.length === 1 && allImages.length === 1) {
          var imgHTML = allImages[0].innerHTML;
          var aTag = allLinks[0].querySelector('a');
          allImages[0].innerHTML = "<a href=\"".concat(aTag.href, "\" target=\"").concat(aTag.target, "\">").concat(imgHTML, "</a>");
        } else if (allLinks.length > 0 && allImages.length > 0) {
          var allItems = Array.prototype.slice.call(element.querySelectorAll('.element__item'));
          var curImage = null;
          allItems.forEach(function (item) {
            if (item.classList.contains('element__item__image')) {
              curImage = item;
            } else if (item.classList.contains('element__item__link')) {
              if (curImage) {
                var _imgHTML = curImage.innerHTML;
                var _aTag = item.querySelector('a');
                curImage.innerHTML = "<a href=\"".concat(_aTag.href, "\" target=\"").concat(_aTag.target, "\">").concat(_imgHTML, "</a>");
              }
            } else {
              curImage = null;
            }
          });
        }
      });
    });
  })();
} catch (error) {
  console.log(error);
}